import React from 'react';
import PropTypes from 'prop-types';

export default function ArrowCircleIcon(props) {
  const { fill, width, height, className } = props;

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 36 36'
      className={className}
    >
      <g id='Grupo_13335' data-name='Grupo 13335' transform='translate(-312.865 -1017.865)'>
        <g
          id='Elipse_1'
          data-name='Elipse 1'
          transform='translate(312.865 1017.865)'
          fill='none'
          stroke={fill}
          strokeWidth='1'
        >
          <circle cx='18' cy='18' r='18' stroke='none' />
          <circle cx='18' cy='18' r='17.5' fill='none' />
        </g>
        <path
          id='Caminho_146'
          data-name='Caminho 146'
          d='M347.2,2964.4H333.4l4.809-6.043a.683.683,0,0,0-1.069-.849l-5.692,7.153c-.006.007-.011.016-.016.024s-.021.03-.03.045-.024.042-.034.064-.015.032-.021.046-.016.05-.024.077a.414.414,0,0,0-.011.043.712.712,0,0,0,0,.252c0,.015.008.029.011.043a.5.5,0,0,0,.024.077.438.438,0,0,0,.021.046c.01.022.022.043.034.064s.02.03.03.045.01.016.016.024l5.692,7.152a.683.683,0,0,0,1.069-.85l-4.809-6.043h13.8a.686.686,0,0,0,0-1.372Z'
          transform='translate(-8.939 -1928.883)'
          fill={fill}
          stroke={fill}
          strokeWidth='1'
        />
      </g>
    </svg>
  );
}

ArrowCircleIcon.defaultProps = {
  fill: '#41a152',
  width: 30,
  height: 30
};

ArrowCircleIcon.propTypes = {
  fill: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  className: PropTypes.string
};
